"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFES_FRONTEND_GENERATED_URLS = void 0;
const enums_1 = require("./enums");
exports.MFES_FRONTEND_GENERATED_URLS = [
    enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNT_CONTRIBUTIONS,
    enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNTS_DATA_AGGREGATION,
    enums_1.ClientExposedUrl.WEBCOMPONENT_ACTIVE_IN_ADVICE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_ACTIVE_RISK_ASSESSMENT,
    enums_1.ClientExposedUrl.BACKEND_MONEY_TO_WORK,
    enums_1.ClientExposedUrl.WEBCOMPONENT_CASHFLOW,
    enums_1.ClientExposedUrl.WEBCOMPONENT_CONFIRMATION_PAGE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_CUSTOM_GOAL,
    enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER,
    enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER_INACTIVE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_PLAN_ADHERENCE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_EMERGENCY_SAVINGS,
    enums_1.ClientExposedUrl.WEBCOMPONENT_EXEMPLAR_FRONTEND,
    enums_1.ClientExposedUrl.WEBCOMPONENT_FINANCIAL_GOAL_TRADEOFFS,
    enums_1.ClientExposedUrl.FINANCIAL_GOAL_TRADEOFFS,
    enums_1.ClientExposedUrl.WEBCOMPONENT_MONEY_TO_WORK,
    enums_1.ClientExposedUrl.WEBCOMPONENT_MY_PLAN_PAGE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_OFFER_UPGRADE_DOWNGRADE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_PORTFOLIO_BUILDER,
    enums_1.ClientExposedUrl.WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE_INACTIVE,
    enums_1.ClientExposedUrl.WEBCOMPONENT_VMAP_POST_CONVERSION,
    enums_1.ClientExposedUrl.WEBCOMPONENT_HOUSEHOLD_MANAGEMENT
];
